import { useCallback } from "react";

import { useToast } from "@chakra-ui/react";

import { downloadBlob } from "util/downloadBlob";

const useDownloadFile = () => {
  const toast = useToast();
  return useCallback(
    (file: Pick<DocumentsFile, "filename" | "mimeType" | "url">) => {
      if (!file.url) {
        toast({
          position: "top-right",
          description: "Invalid or missing file download URL",
          duration: 2000,
          status: "error",
        });
        return Promise.reject("No file download url");
      }
      return downloadBlob(
        `${process.env.REACT_APP_API_HOST}${file.url}`,
        file.filename,
        file.mimeType
      ).catch(() => {
        toast({
          position: "top-right",
          description: `Failed to download file ${file.filename}`,
          duration: 2000,
          status: "error",
        });
      });
    },
    [toast]
  );
};

export default useDownloadFile;
